import {
    ISRESULT,
    GET_DATA_LAYOUT_LAYOUT, GET_DATA_LAYOUT_LAYOUT_SUCCEEDED, REQUERT_LAYOUT_LAYOUT_FAILED, SET_DATA_LAYOUT_LAYOUT,
    GET_DATA_Notification, GET_DATA_Notification_SUCCEEDED, REQUERT_Notification_FAILED,SET_DATA_LOGOUT,REQUERT_SET_DATA_LOGOUT_FAILED, UPDATE_DATA_NOTIFICATION, GET_DATA_LOGOUT_SUCCEEDED
    //IndexImportHygen
} from './actionTypes';

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//LayoutLayout
export const GetDataLayoutLayoutAction = () => {
    return {
        type: GET_DATA_LAYOUT_LAYOUT
    }
}
export const GetDataLayoutLayoutSuccessAction = (DataLayout) => {
    return {
        type: GET_DATA_LAYOUT_LAYOUT_SUCCEEDED,
        DataLayout: DataLayout
    }
}
export const RequertLayoutLayoutFaileAction = (Err) => {
    return {
        type: REQUERT_LAYOUT_LAYOUT_FAILED,
        err: Err
    }
}
export const SetDataLayoutLayoutAction = (DataLayout) => {
    return {
        type: SET_DATA_LAYOUT_LAYOUT,
        DataLayout: DataLayout
    }
}
//Noti
export const GetDataNotificationAction = (DataNoti) => {
    return {
        type: GET_DATA_Notification,
        DataNoti: DataNoti
    }
}
export const GetDataNotificationSuccessAction = (DataNoti) => {
    return {
        type: GET_DATA_Notification_SUCCEEDED,
        DataNoti: DataNoti
    }
}
export const RequertNotificationFaileAction = (Err) => {
    return {
        type: REQUERT_Notification_FAILED,
        err: Err
    }
}
export const UpdateDataNotificationAction = () =>{
    return {
        type: UPDATE_DATA_NOTIFICATION
    }
}
//LogOut
export const LogOut = () => {
    return {
        type: SET_DATA_LOGOUT
    }
}
export const LogOutSuccessAction = (data) => {
    return {
        type: GET_DATA_LOGOUT_SUCCEEDED,
        data: data
    }
}
export const RequertLogOutFaileAction = (Err) => {
    return {
        type: REQUERT_SET_DATA_LOGOUT_FAILED,
        err: Err
    }
}
//IndexUsingHygen